import { parseCustomer } from '@/customer/converters/customerConverters';
import { DossierId } from '@/dossier/models/AbstractDossier';
import { parseEntities, parseEntity } from '@/shared/converters/commonConverters';
import OptInOption from '../constants/OptInOption';
import ContactData from '../models/ContactData';
import DossierContact from '../models/DossierContact';

const SCHEMA = {
  id: (data: any) => data.dossierContactId ?? data.id,
  isMain: 'isMain',
  isLeasing: 'isLeasing',
  dossierId: 'dossierId',
  customer: parseCustomer,
};

export function parseDossierContact(data: any, dossierId: DossierId): DossierContact | null {
  const contact = parseEntity(data, SCHEMA, DossierContact);
  if (contact) contact.dossierId = dossierId;
  return contact;
}

export function parseDossierContacts(data: any, dossierId: DossierId): Array<DossierContact> {
  return parseEntities(data, d => parseDossierContact(d, dossierId));
}

export function formatDossierContact(data: ContactData): any {
  return {
    contactType: data.type,
    title: data.title,
    firstName: data.firstName,
    lastName: data.lastName,
    language: data.language,
    firstEmail: data.email || null,
    secondEmail: data.secondEmail || null,
    thirdEmail: data.thirdEmail || null,
    // if value is for example '+32', backend should handle it as empty string, but that's not the case (it is the case for mobile phones)
    firstPhoneNumber: data.phone.length <= 3 ? '' : data.phone,
    secondPhoneNumber: data.secondPhone.length <= 3 ? '' : data.secondPhone,
    firstMobileNumber: data.mobilePhone.length <= 3 ? '' : data.mobilePhone,
    secondMobileNumber: data.secondMobilePhone.length <= 3 ? '' : data.secondMobilePhone,
    vatNumber: data.vat,
    optOut: false,
    emailOptIn: data.optInOptions.includes(OptInOption.EMAIL),
    smsOptIn: data.optInOptions.includes(OptInOption.SMS),
    preferredChannel: null,
  };
}